"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeUnwrapOrNull = void 0;
const is_defined_1 = require("../is-defined");
const safeUnwrapOrNull = (value, ok) => (((0, is_defined_1.isDefined)(value) && (0, is_defined_1.isNotNull)(value)) ? ok(value) : null);
exports.safeUnwrapOrNull = safeUnwrapOrNull;
